
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: "fetal_maturity_test",
components: {
XTable,
},
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/fetal_maturity_test.vue